import React from 'react';
import { useTranslation } from 'react-i18next';
import './Illustrations.css';

const ROWS = [
  { labelKey: 'projectA', status: 'on-track', progress: 0.45 },
  { labelKey: 'projectB', status: 'follow-up', progress: 0.8 },
  { labelKey: 'projectC', status: 'on-track', progress: 0.3 },
];

const ROW_TOP = 28;
const ROW_GAP = 60;
const BAR_WIDTH = 92;

/**
 * A short project list with traffic-light status, one project flagged for follow-up.
 * @returns {JSX.Element} Decorative drawing
 */
function ProjectsIllustration() {
  const { t } = useTranslation();
  const flaggedRowTop = ROW_TOP + ROW_GAP;

  return (
    <svg className="illustration" viewBox="0 0 320 220" aria-hidden="true" focusable="false">
      {ROWS.map((row, index) => {
        const y = ROW_TOP + index * ROW_GAP;
        const barClass = row.status === 'follow-up' ? 'ill-orange' : 'ill-navy';

        return (
          <g key={row.labelKey}>
            <rect className="ill-paper" x="32" y={y} width="256" height="46" rx="14" />
            <circle className={`ill-status-${row.status}`} cx="58" cy={y + 23} r="8" />
            <text className="ill-text ill-text-navy" x="76" y={y + 28} fontSize="14">
              {t(`illustrations.projects.${row.labelKey}`)}
            </text>
            <rect className="ill-line" x="172" y={y + 19} width={BAR_WIDTH} height="8" rx="4" />
            <rect className={barClass} x="172" y={y + 19} width={BAR_WIDTH * row.progress} height="8" rx="4" />
          </g>
        );
      })}

      <rect className="ill-orange" x="200" y={flaggedRowTop - 13} width="76" height="24" rx="12" />
      <text
        className="ill-text ill-text-white"
        x="238"
        y={flaggedRowTop + 3}
        fontSize="11"
        textAnchor="middle"
      >
        {t('illustrations.projects.followUp')}
      </text>
    </svg>
  );
}

export default ProjectsIllustration;
